<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Highfive" class="d-icon d-icon--highfive" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" fill="#fff"/><path d="m6.762 17.235-1.833 1.833a9.968 9.968 0 0 0 7.07 2.928v-2.595a7.37 7.37 0 0 1-5.237-2.166Z" fill="#F7AFFF"/><path d="M4.595 11.998a7.405 7.405 0 0 1 7.407-7.406V2C6.478 2 2 6.478 2 11.998a9.967 9.967 0 0 0 2.929 7.07l1.833-1.833a7.379 7.379 0 0 1-2.167-5.237Z" fill="#A26EEA"/><path d="m17.235 6.762 1.833-1.833A9.968 9.968 0 0 0 11.998 2v2.595c2.046 0 3.897.826 5.237 2.167Z" fill="#46B7FD"/><path d="M22 11.998a9.967 9.967 0 0 0-2.929-7.07l-1.833 1.834a7.405 7.405 0 0 1-5.237 12.643V22C17.523 22 22 17.522 22 11.998Z" fill="#5D70EA"/><path d="M11.998 14.296a2.297 2.297 0 1 0 0-4.595 2.297 2.297 0 0 0 0 4.595Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHighfive',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
